// extracted by mini-css-extract-plugin
export default {"wrapper":"Admin_wrapper__-BOYH","content":"Admin_content__zL4v+","title":"Admin_title__dg-rU","sidebar":"Admin_sidebar__BqEyP","navMenu":"Admin_navMenu__RPHmB"};